export default __webpack_public_path__ + "locales/uk-UA/DataReassignmentDialog.json?hash=493931bc77ef9f598876cb27c1e2119c";